module.exports = __webpack_public_path__ + "media/images/flags/to-a1e35d19986200708ab355eb02a74acb.svg";